module.exports = __webpack_public_path__ + "img/4-2.56b9a570.svg";